module.exports = __webpack_public_path__ + "static/icon-crypto-loans-5f6dbef95c9c0b4c4ecd717a2824ab6b.svg";